// extracted by mini-css-extract-plugin
export var cgLanguagePicker = "LanguagePicker-module--cg-language-picker--1177f";
export var cgLanguagePickerButton = "LanguagePicker-module--cg-language-picker-button--458bc";
export var cgLanguagePickerButtonContent = "LanguagePicker-module--cg-language-picker-button-content--d1551";
export var cgLanguagePickerMenu = "LanguagePicker-module--cg-language-picker-menu--8fa8e";
export var flag = "LanguagePicker-module--flag--42dff";
export var label = "LanguagePicker-module--label--96553";